// extracted by mini-css-extract-plugin
export default {"cls1":"oeb08xnoIWmq2fsqvc5g","cls2":"XtIrbMjjlDBhmFJLoN19 oeb08xnoIWmq2fsqvc5g"};